export default __webpack_public_path__ + "static/media/coinSound.9da33c66.mp3";